import {Injectable} from '@angular/core';
import posthog, {PostHog as PostHogI} from 'posthog-js';
import {currentUser_currentUser} from 'app/core/services/gql/currentUser';

@Injectable()
export class PosthogService {
    private instance: PostHogI;

    constructor() {}

    markOnModeration() {
        if (!this.instance) {
            return console.debug('[Posthog] markOnModeration');
        }
        this.instance.people.set('onModeration', 'true');
    }

    getFeatureFlag(
        key: string,
        options?: {
            send_event?: boolean;
        }
    ): boolean | string | undefined {
        if (!this.instance) {
            console.debug('[Posthog] getFeatureFlag', key, options);
            return;
        }
        return this.instance.getFeatureFlag(key, options);
    }

    init(user: currentUser_currentUser): Promise<void> {
        return new Promise<void>(resolve => {
            posthog.init('phc_JAsdxyQBbBN1SrED6jpPDzhPHE9PsbhpntL4XUgsLaZ', {
                api_host: 'https://app.posthog.com',
                autocapture: {
                    dom_event_allowlist: ['change', 'submit'],
                },
                rageclick: true,
                capture_pageview: true,
                capture_pageleave: true,
                loaded: (posthog_instance: PostHogI) => {
                    if (user) {
                        posthog.identify(user.id, {
                            createdAt: user.createdAt,
                            isCustomer: user.roles.length === 0 && !user.isDemoAccount,
                        });
                    }

                    this.instance = posthog_instance;
                    resolve();
                },
            });
        });
    }

    logEvent(event_name: string, properties?: Record<string, any> | null) {
        if (!this.instance) {
            return console.debug('[Posthog] capture', event_name, properties);
        }
        this.instance.capture(event_name, properties);
    }

    onSignOut = () => this.instance?.reset(true);
}
